import { render, staticRenderFns } from "./IndividualCompetenceCompareLocals.vue?vue&type=template&id=477e7f08&scoped=true"
import script from "./IndividualCompetenceCompareLocals.vue?vue&type=script&lang=js"
export * from "./IndividualCompetenceCompareLocals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477e7f08",
  null
  
)

export default component.exports